/* eslint-disable @nx/enforce-module-boundaries */
import { Input, PopoverTrigger } from "@chakra-ui/react"
import { GifIcon, GifIconV2 } from "@mybridge/icons"
import { IconButton } from "@mybridge/ui/icon-button"
import { useDisclosure } from "@mybridge/ui/hooks"
import { Popover, PopoverBody, PopoverContent } from "@mybridge/ui/popover"
import { useContext , useState ,useEffect,useRef} from "react"
import Giphy from "@mybridge/ui/giphy"
import { PostFormContext } from "../context"
import { Tooltip } from "@mybridge/ui/tooltip"
import { Box } from "@mybridge/ui/layout"
import { useTranslator } from "@mybridge/ui/custom-hooks/useTranslation"
import { Spinner } from "@chakra-ui/react"
export const GifPicker = ({ hideOnSelect = true }) => {
    const { setGifs, images, videos, convertAndUploadThumbnail } = useContext(PostFormContext)
    const { isOpen, onClose, onToggle } = useDisclosure()
    const [searched, setSearched] = useState(false)
    const [query, setQuery] = useState('')
     const [isGiphyLoading, setIsGiphyLoading] = useState(false)
    const onSelect = (gif) => {
        setGifs?.([gif])
        convertAndUploadThumbnail(gif?.images?.original?.url)
        if (hideOnSelect) {
            onClose()
        }
    }
    const [iconColor, setIconColor] = useState('');
    const { t } = useTranslator();
    const loadingTimeoutRef = useRef(null)
    const handleMouseEnter = () => {
        setIconColor('#ffffff');
    };
  
    const handleMouseLeave = () => {
      setIconColor('');
    };
  const handleGiphyLoaded = () => {
        setIsGiphyLoading(false)
        if (loadingTimeoutRef.current) {
            clearTimeout(loadingTimeoutRef.current)
        }
    }

    // Handle popover opening with loading state
    const handleToggle = () => {
        if (!isOpen && !isGiphyLoading) {
            setIsGiphyLoading(true)
            onToggle()
            
            // Fallback timeout in case onLoad callback doesn't fire
            loadingTimeoutRef.current = setTimeout(() => {
                setIsGiphyLoading(false)
            }, 3000) // 3 seconds fallback
        } else if(isOpen){
            onToggle()
        }
    }

    // Reset loading state when popover closes
    useEffect(() => {
        if (!isOpen) {
            setIsGiphyLoading(false)
            if (loadingTimeoutRef.current) {
                clearTimeout(loadingTimeoutRef.current)
            }
        }
    }, [isOpen])
     // Cleanup timeout on unmount
    useEffect(() => {
        return () => {
            if (loadingTimeoutRef.current) {
                clearTimeout(loadingTimeoutRef.current)
            }
        }
    }, [])

    const handleSearch = (e) => {
      const value = e.target.value
      setQuery(value)
      setSearched(value.trim().length > 0) // switch to search if not empty
    }
    return (
        <>
            <Popover
                isOpen={isOpen}
                onClose={onClose}
            >
                <PopoverTrigger>
                    <Box>
                        <Tooltip variant="round" label={t('createPost.addGif') || "Add Gif"}>
                            <IconButton 
                                borderRadius="30px"
                                padding="6px"
                                _hover={{ background: '#3D5A80' }}
                                onMouseEnter={handleMouseEnter}
                                onMouseLeave={handleMouseLeave}
                                isDisabled={images?.length || videos?.length} onClick={handleToggle} 
                              
                                icon={
                                    isGiphyLoading ? (
                                        <Spinner 
                                            size="sm" 
                                            color="#ffffff" 
                                            thickness="2px"
                                        />
                                    ) : (
                                        <GifIconV2 color={iconColor} />
                                    )
                                } 
                                 />
                        </Tooltip>
                    </Box>
                </PopoverTrigger>
                <PopoverContent>
                    <PopoverBody>
      
                          {isOpen ? (<>
                             <Input
                             placeholder="Search for GIFs..."
                             value={query}
                             onChange={handleSearch}
                             mb={6}
                             />
                   
                           <Giphy
                             searchQuery={query}
                             searched={searched}
                             onSelect={onSelect} 
                             onLoad={()=>handleGiphyLoaded()}
                             />
                             </>
                        ) : (
                            ""
                        )}
                    </PopoverBody>
                </PopoverContent>
            </Popover>
        </>
    )
}